import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import twitchIconImage from 'assets/images/icon/twitch.png';

const useStyles = makeStyles(({ palette }) => ({
  root: ({ background }) => ({
    background,
    width: '35px',
    height: '35px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  }),
  image: {
    filter: palette.invertImage,
  },
}));

const ShareButton = ({ ...props }) => {
  const { onClick } = props;
  const classes = useStyles(props);

  return (
    <Box className={classes.root} onClick={onClick}>
      <img src={twitchIconImage} alt="Icon" className={classes.image} />
    </Box>
  );
};

ShareButton.defaultProps = {
  background: 'transparent',
  onClick: () => {},
};

ShareButton.propTypes = {
  background: PropTypes.string,
  onClick: PropTypes.func,
};

export default ShareButton;
